// What each column means, shown on hover of the info icon beside the column title.

export const EXCALIBUR_COLUMN_INFO = {
    useCase: "Country or tax regime for the report generation.",
    subUseCase: "The kind of report generated.",
    status: "Current status of the request.",
    startTimestamp: "Date and time the request was submitted.",
    createdBy: "Login alias of the user who submitted the request.",
    inputFileKey: "File uploaded for this request.",
    generatedFileKey: "The report generated from the input file.",
    errorDetails: "Why the request failed, if it did, Download error report gives the pre-validation file.",
    txnArtifacts: "Supporting files for this request."
};

export const FILING_COLUMN_INFO = {
    useCase: "Country or tax regime the filing was submitted to.",
    subUseCase: "The kind of filing made for that country.",
    taxIdentifier: "Invoice number or entity code for each filing.",
    status: "Current status of the filing.",
    startTimestamp: "Date and time the filing was submitted.",
    createdBy: "Login of the user who submitted the filing.",
    inputFileKey: "The file submitted for filing; click to download it.",
    getReceipt: "Proof of submission for this entity.",
    transactionDetails: "How many entities in the filing failed, More Info opens their individual errors.",
    txnArtifacts: "Supporting files for this request."
};

export const TASK_COLUMN_INFO = {
    taskId: "Unique id of this entity's task within the transaction.",
    taxIdentifier: "Invoice number or entity code for each filing.",
    status: "Outcome for this entity.",
    taskInputFile: "The input used for this entity, empty when no file is stored for it.",
    submissionReceipt: "Proof of submission for this entity.",
    generatedReport: "The report produced for this entity from its input; empty when none was generated.",
    errorDetails: "Why this entity failed, if it did; hover the text to read the full message."
};

// What each status value means, listed in the Status column's info tooltip; order is roughly the lifecycle.

export const EXCALIBUR_STATUS_INFO = [
    ["INQUEUE", "Request queued, not started yet."],
    ["PROCESSING", "Report generation running."],
    ["SUCCESS", "Report generated, no validation errors."],
    ["CONDITIONAL_SUCCESS", "Report generated, some rows failed pre-validation; see the error report."],
    ["FAILURE", "Generation failed; an error report may exist."],
    ["EXCEPTION", "Internal error stopped the run."]
];

export const FILING_STATUS_INFO = [
    ["PROCESSING", "Filing accepted and running."],
    ["SUCCESS", "Every entity filed and accepted."],
    ["PARTIAL_SUCCESS", "Some entities filed, some failed."],
    ["FAILURE", "Filing failed for all entities, or before submission."],
    ["EXCEPTION", "Internal error stopped the run."],
    ["TRANSMISSION_COMPLETED", "Submitted to the GIS."],
    ["PARTIAL_TRANSMISSION_COMPLETED", "Only part of the file could be submitted."],
    ["ACCEPTED", "Authority accepted the submission."],
    ["ACCEPTED_WITH_ERRORS", "Authority accepted the submission but reported errors."],
    ["AUTHORIZED", "Submitted to the authority."],
    ["WARNING", "Authority accepted the submission with warnings."],
    ["REJECTED", "Authority rejected the submission."],
    ["ERROR", "Authority failed to process the submission."]
];

export const TASK_STATUS_INFO = [
    ["PENDING", "Row created, work not finished."],
    ["SUCCESS", "This entity's file was generated or filed."],
    ["FAILURE", "This entity failed."],
    ["PARTIAL_SUCCESS", "Entity accepted with errors."],
    ["AUTHORIZED", "Authority authorised this entity."],
    ["WARNING", "Authority accepted this entity with warnings."],
    ["REJECTED", "Authority rejected this entity."],
    ["ERROR", "Authority failed to process this entity."]
];
